import React from "react";
import Acquirer from "enums/Acquirer";
import { CheckoutProps } from "./types";

type CheckoutComponent = React.LazyExoticComponent<React.FC<CheckoutProps>>;

const registry: Partial<Record<Acquirer, CheckoutComponent>> = {
  [Acquirer.STRIPE]: React.lazy(
    () => import("./stripe/StripeCheckoutProvider"),
  ),
};

export default registry;
